module.exports = __webpack_public_path__ + "img/27_29.41af3be4.png";